import { render } from "./create_section_question.html?vue&type=template&id=72db0db6&external"
import script from "./create_section_question.js?vue&type=script&lang=js&external"
export * from "./create_section_question.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__